import React from "react";
import styles from "../styles/Thank-you.module.css";
import ArrowImage from '../assets/c76212997d0f8946be77e6aa0c242950b8adb5d1104fed148350fcf23926febd.webp';
const OfferBanner: React.FC = () => {
  return (
    <div className={styles.offerBanner}>
      <div className={styles.offerContent}>
        <img
          src={ArrowImage}
          alt="Offer Icon"
          className={styles.offerIcon}
        />
        <span className={styles.offerText}>Exclusive Limited Time Offer</span>
        <img
          src={ArrowImage}
          alt="Offer Icon"
          className={styles.offerIcon}
        />
      </div>
    </div>
  );
};

export default OfferBanner;
